module.exports = __webpack_public_path__ + "static/media/productImg4.12bc6ae1.png";